import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/Button';
import { routerUrls } from '@/configs/routes/routerUrls';

import s from './NotFoundPage.module.scss';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <h1 className={s.title}>404</h1>
        <div className={s.description}>Страница не найдена</div>
        <div className={s.subdescription}>
          Запрашиваемая страница не существует или была перемещена
        </div>
        <Button onClick={() => navigate(routerUrls.root)} className={s.button}>
          Вернуться на главную
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
